import { ACCESS_CODE_LOADING, ACCESS_CODE_CORRECT, ACCESS_CODE_INCORRECT, ACCESS_CODE_ERROR, DIGITAL_DOWNLOAD_RESET, DOWNLOAD_SUCCESS } from "../actions/Consts";

const initialState = {
	loading: false,
	errorMsg: "",
	error: "",
	status: "",
	fileName: "",
	filePath: "",
	fileSize: "",
	downloadLeft: "",
	downloadLimit: "",
	downloadingStarted: false
}
const DigitalDownloadReducer = (state = initialState, { type, payload }) =>{
	console.log(state, type,payload);
	
	switch(type){
		case ACCESS_CODE_LOADING:
			return {
				...initialState,
				loading: true
			};
		case ACCESS_CODE_CORRECT: 
		case ACCESS_CODE_INCORRECT:
		case ACCESS_CODE_ERROR:
			return {
				...initialState,
				...payload
			};
		case DOWNLOAD_SUCCESS:
			return {
				...payload,
				...initialState,
				downloadingStarted:true
			}
		case DIGITAL_DOWNLOAD_RESET:
			return {
				...initialState
			}
		 default:
		 	return state
	}
}
export default DigitalDownloadReducer